import io from 'socket.io-client';
import { useUserStore } from '../stores/UserStore';
import { CONFIG } from './config';

export const socketConnect = () => {
  const TOKEN = useUserStore.getState().TOKEN;
  return io(CONFIG.SOCKET_URL + '?token=' + TOKEN, {
    transports: ['websocket']
  });
};
